import { defineComponent as _defineComponent } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { ref } from 'vue'
import Breadcrumb from '../components/ui/breadcrumb/Breadcrumb.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutMap',
  setup(__props) {

const crumbs = ref([
	{ name: 'Cadastro', step: 0 },
	{ name: 'Planejamento', step: 1 },
])

const recuo = useLocalStorage('storageRecuo', 0)

const step = ref(1)

return { __sfc: true,crumbs, recuo, step, Breadcrumb }
}

})